import moment from "moment";

/**
 * Basic Station model.
 *
 */
class ForecastModel {
  constructor(props) {
    this.id = props.id;
    this.name = props.name;
    this.latitude = props.latitude;
    this.longitude = props.longitude;
    this.enabled = props.enabled;
    this.active = props.active;
    this.serialNumber = props.serialNumber;
    this.xbaseid = props.xbaseid;
    this.latestMeasurement = props.latestMeasurement;

    this.startDate = null;
    if (props.activePeriodStart) {
      this.startDate = moment(props.activePeriodStart, "X");
    }

    this.endDate = null;
    if (props.activePeriodEnd) {
      this.endDate = moment(props.activePeriodEnd, "X");
    }

    this.forecast = {};
    this.sprayplanner = {};
    this.measurements = {};
  }
}

export default ForecastModel;
